import React, { Component, useId } from 'react';
import { Modal, Select, Button, Spin, message } from 'antd';
import TableC from '../../../basicElement/TableC';
import Fetch from '../../../../common/Fetch';
import API_URL from '../../../../common/url';
import $ from 'jquery';

const { Option } = Select;
let isCSA = true;
let isBA = true;

class ProjectSplit extends Component {
    state = {
        visible: false,
        loading: false,
        data: [],
        selectedRowKeys: [],
        record: {},
        sortParams: {},
        userId: undefined,
        canBASplit: false,
        canOperate: false,
        CSAuserId: undefined,
        BAuserId: undefined,
    }

    loadData = () => {
        const { sortParams, record: { customerCompanyId } } = this.state;
        this.setState({ loading: true });
        Fetch.post(API_URL.contract.queryCustomerCompanyInvList, {
            customerCompanyId,
            ...sortParams
        }).then(res => {
            const { userId } = sessionStorage;
            const data = res.datas || [];
            let selectedRowKeys = [];
            if (isCSA) {
                selectedRowKeys = data.filter(i => i.userId == userId).map(i => i.investigationId);
            }
            this.setState({
                data,
                loading: false,
                selectedRowKeys,
            });
        }).catch(err => {
            console.error(err);
            this.setState({ loading: false });
        });
    }

    show = (record, boolCSA, boolBA, canBASplit, canOperate) => {
        isCSA = boolCSA;
        isBA = boolBA;
        const { userId } = sessionStorage;
        this.setState({
            canBASplit,
            canOperate,
            record,
            visible: true,
            userId: (isCSA || isBA) ? userId : undefined,
        }, () => {
            this.loadData();
        });
    }

    hide = () => {
        this.setState({ 
            visible: false,
            userId: undefined,
            canBASplit: false,
            CSAuserId: undefined,
            BAuserId: undefined,
        }, () => {
            $('.tableC .transferCompany .ant-table-body').scrollTop(0);
        });
    }

    getColumns = () => [{
        title: '项目简称',
        dataIndex: 'investigationName',
        key: 'investigationName',
    }, {
        title: 'JDE主项目号',
        dataIndex: 'jdeMainCode',
        key: 'jdeMainCode',
        width: 100,
    }, {
        title: 'JDE项目号',
        dataIndex: 'jdeCodes',
        key: 'jdeCodes',
        width: 200,
    }, {
        title: '负责CSA',
        dataIndex: 'userCompellation',
        key: 'userCompellation',
        sorter: true,
        width: 100,
    }, {
        title: '负责BA',
        dataIndex: 'baUserName',
        key: 'baUserId',
        width: 100,
    }]

    onSelectChange = (record, selected) => {
        const { investigationId } = record;
        let list = [...this.state.selectedRowKeys];
        if (selected) {
            list.push(investigationId);
        } else {
            list = list.filter(i => i != investigationId);
        }
        this.setState({ selectedRowKeys: list });
    }

    onSelectAllChange = (selected, selectedRows, changeRows) => {
        let hasEmpty = false;
        let list = [...this.state.selectedRowKeys];
        if (selected) {
            changeRows.forEach(i => {
                if (!i.userId) {
                    hasEmpty = true;
                    list.push(i.investigationId);
                }
            });
        }
        if (!selected || !hasEmpty) {
            list = [];
        }
        this.setState({ selectedRowKeys: list });
    }

    handleSelectChange = (value, key) => {
        if (key == 'BA') {
            this.setState({ BAuserId: value });
        }else{
            this.setState({ CSAuserId: value });
        }
        this.setState({ userId: value });
    }

    getCheckboxProps = (record) => {
        const { userId: baId } = record;
        const { userId } = sessionStorage;
        const { canOperate } = this.state;
        return {
            disabled: (isCSA && !canOperate) ? (baId && baId != userId)  : false
        };
    }

    handleTableChange = (params) => {
        this.setState(...params, () => {
            this.loadData();
        });
    }

    submit = (key) => {
        const { userId, data, selectedRowKeys } = this.state;
        // 是否已分配给其他BA
        console.log(userId,selectedRowKeys,data);
        let hasSplit = false;
        if (key === 'BA') {
            hasSplit = selectedRowKeys
                .map(i => data.find(d => d.investigationId == i))
                .some(i => i.baUserId && i.baUserId != userId);
        }else{
            hasSplit = selectedRowKeys
                .map(i => data.find(d => d.investigationId == i))
                .some(i => i.userId && i.userId != userId);
        }
        if (hasSplit) {
            Modal.confirm({
                iconType: 'exclamation-circle',
                title: <div style={{ marginLeft: 42 }}>本次分配的项目中，有项目已经存在其他负责{key}，确认执行分配？</div>,
                content: `确认执行后，已分配的负责${key}将被覆盖`,
                onOk: () => this.save()
            });
        } else {
            this.save();
        }
    }

    save = () => {
        const { userId, record, selectedRowKeys, canBASplit, canOperate } = this.state;
        const { customerCompanyId } = record;
        this.setState({ loading: true });
        let url;
        if (canBASplit) {
            url = API_URL.contract.saveCustomerBaInv;
        }else{
            url = API_URL.contract.saveBaInv;
        }
        Fetch.post(url, {
            userId,
            customerCompanyId,
            ids: selectedRowKeys.join()
        }).then(res => {
            message.success(res.success);
            this.setState({
                loading: false,
            }, () => {
                (isCSA && !canOperate) ? this.hide() : this.loadData();
                this.props.loadData();
            });
        }).catch(err => {
            console.error(err);
            this.setState({ loading: false });
        });
    }

    render() {
        const { visible, loading, data, record, sortParams, selectedRowKeys, userId, canBASplit, canOperate, CSAuserId, BAuserId } = this.state;
        const { baList, csaList, customerCompanyName } = record;
        const { curRole }= sessionStorage;
        const isBAL = curRole == 'BAL';
        const isCSAL = curRole == 'CSAL';
        const rowSelection = {
            selectedRowKeys,
            onSelect: this.onSelectChange,
            onSelectAll: this.onSelectAllChange,
            getCheckboxProps: this.getCheckboxProps,
        };
        const csaOption = (csaList || []).map(i => <Option key={i.userId}>{i.userCompellation}[{i.employeeCode}]</Option>);
        const baOption = (baList || []).map(i => <Option key={i.userId}>{i.userCompellation}[{i.employeeCode}]</Option>);
        const settings = {};
        if (!isCSA) {
            settings.footer = <Button onClick={this.hide}>关闭</Button>;
        }
        return (
            <Modal
                title="项目拆分"
                visible={visible}
                onOk={this.submit}
                onCancel={this.hide}
                maskClosable={false}
                confirmLoading={loading}
                bodyStyle={{ maxHeight: 500 }}
                width="800px"
                {...settings}
            >
                <Spin spinning={loading}>
                    <p>客户名称：{customerCompanyName}</p>
                    <p style={{ margin: '10px 0', color: '#F63' }}>
                        { (isCSA && !canOperate) ? '请勾选你负责的项目（不可勾选的项目，表示已经由他人负责，如要修改，请联系BAL）' : '请为各CSA/BA分配各自负责的项目' }
                    </p>
                    <TableC
                        scrollY={220}
                        data={data}
                        sortParams={sortParams}
                        columns={this.getColumns()}
                        onChange={this.handleTableChange}
                        className="projectSplit"
                        rowKey="investigationId"
                        rowSelection={rowSelection}
                    />
                    {
                        ((!isCSA || canOperate) && !canBASplit) &&
                        <div style={{ marginTop: 10 }}>
                            CSA
                            <Select
                                value={CSAuserId}
                                placeholder="请选择"
                                style={{ margin: '0 10px', width: 160 }}
                                onChange={this.handleSelectChange}
                            >
                                {csaOption}
                            </Select>
                            <Button type="primary" disabled={ canBASplit || !CSAuserId || !(selectedRowKeys || []).length} onClick={() => this.submit('CSA')}>确认分配</Button>
                        </div>
                    }
                    {
                        canBASplit &&
                        <div style={{ marginTop: 10 }}>
                        &nbsp;&nbsp;BA
                            <Select
                                value={BAuserId}
                                placeholder="请选择"
                                style={{ margin: '0 10px', width: 160 }}
                                onChange={ value => this.handleSelectChange(value, 'BA')}
                            >
                                {baOption}
                            </Select>
                            <Button type="primary" disabled={isCSAL || !BAuserId || !(selectedRowKeys || []).length} onClick={() => this.submit('BA')}>确认分配</Button>
                        </div>
                    }     
                </Spin>
            </Modal>
        );
    }
}


export default ProjectSplit;


// WEBPACK FOOTER //
// ./src/components/contractManagement/responseCustomer/Components/ProjectSplit.js